module.exports = __webpack_public_path__ + "img/BG-2.4921733.png";